"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeStylesMixin = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  ", ";\n  ", ";\n  line-height: ", ";\n  min-height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  font-size: ", ";\n  ", ";\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: inherit;\n  hyphens: manual;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var badgeTextStyles = (0, _styledComponents.css)(_templateObject(), _Styles.FONT_FAMILIES.bold, _sizes.BADGE_ROUNDED_FONT_SIZE, (0, _Styles.setFontSmoothing)('antialiased'));
var badgeStylesMixin = (0, _styledComponents.css)(_templateObject2(), badgeTextStyles, (0, _Styles.setBorderRadius)(), _sizes.BADGE_ROUNDED_HEIGHT, _sizes.BADGE_ROUNDED_HEIGHT);
exports.badgeStylesMixin = badgeStylesMixin;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/badge/internal.js
// module id = 591
// module chunks = 5 6